import { SiteStyle } from './schema';

const MAGNITUDE_VALUES = {
  tiny: [0.25],
  xxsmall: [0.5],
  xsmall: [1, 0.75],
  small: [1.5, 1.25],
  medium: [2, 1.5],
  large: [3, 2, 2.5],
  xlarge: [4, 2.5, 3.5],
  xxlarge: [5, 3, 4.5],
  huge: [6, 3.5, 5],
  xhuge: [7, 4, 6],
  xxhuge: [10, 5, 7.5],
};

/** Magnitude values used by Relume styleguide padding & margin styles */
export const MAGNITUDE_NAMES = Object.keys(MAGNITUDE_VALUES);

const aClass = {
  type: 'class' as const,
  comb: '' as const,
  children: [],
  variants: {},
  affects: {},
} satisfies Partial<SiteStyle>;

export const SPACER_STYLES = Object.entries(MAGNITUDE_VALUES).map<SiteStyle>(
  ([mag, value]) => {
    let variants = {};
    if (value.length === 2) {
      variants = {
        small: {
          sel: `.spacer-${mag}`,
          styleLess: `padding-top: ${value[1]}rem;`,
        },
      };
    }
    if (value.length === 3) {
      variants = {
        medium: {
          sel: `.spacer-${mag}`,
          styleLess: `padding-top: ${value[2]}rem;`,
        },
        small: {
          sel: `.spacer-${mag}`,
          styleLess: `padding-top: ${value[1]}rem;`,
        },
      };
    }
    return {
      _id: `relumeSpacerStyles--${mag}--root`,
      data: {
        ...aClass,
        name: `spacer-${mag}`,
        sel: `.spacer-${mag}`,
        styleLess: `width: 100%; padding-top: ${value[0]}rem;`,
        variants,
      },
    };
  },
);

// TODO replace this with a reference to `styleGuide` once the empty class issue is fixed
export const MARGIN_STYLES = [
  ...['top', 'bottom'].flatMap<SiteStyle>((dir) => {
    const styleLess =
      dir === 'top'
        ? 'margin-right: 0rem; margin-bottom: 0rem; margin-left: 0rem;'
        : 'margin-top: 0rem; margin-right: 0rem; margin-left: 0rem;';
    return [
      {
        _id: `relumeMarginStyles--${dir}--root`,
        data: {
          ...aClass,
          name: `margin-${dir}`,
          sel: `.margin-${dir}`,
          styleLess,
          children: MAGNITUDE_NAMES.map(
            (mag) => `relumeMarginStyles--${dir}--${mag}`,
          ),
        },
      },
      ...MAGNITUDE_NAMES.map<SiteStyle>((mag) => ({
        _id: `relumeMarginStyles--${dir}--${mag}`,
        data: {
          ...aClass,
          name: `margin-${mag}`,
          sel: `.margin-${dir}.margin-${mag}`,
          comb: '&',
          styleLess,
        },
      })),
    ];
  }),
  ...Object.entries(MAGNITUDE_VALUES).flatMap<SiteStyle>(([mag, value]) => ({
    _id: `relumeMarginStyles--${mag}--root`,
    data: {
      ...aClass,
      type: 'class',
      name: `margin-${mag}`,
      sel: `.margin-${mag}`,
      styleLess: `margin-top: ${value}rem; margin-right: ${value}rem; margin-bottom: ${value}rem; margin-left: ${value}rem;`,
    },
  })),
];
